import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/stores/user.ts'
import MainLayout from '@/layouts/MainLayout.vue'
import UtilisateursPage from '@/pages/admin/UtilisateursPage.vue'
import UtilisateurPage from '@/pages/admin/UtilisateurPage.vue'
import EquipementsPage from '@/pages/admin/EquipementsPage.vue'
import EquipementPage from '@/pages/admin/EquipementPage.vue'
import ProduitsFiltrationPage from '@/pages/admin/ProduitsFiltrationPage.vue'
import ProduitFiltrationPage from '@/pages/admin/ProduitFiltrationPage.vue'
import ClientsPage from '@/pages/admin/ClientsPage.vue'
import ClientPage from '@/pages/admin/ClientPage.vue'
import FabricantsPage from '@/pages/admin/FabricantsPage.vue'
import FabricantPage from '@/pages/admin/FabricantPage.vue'
import HomePage from '@/pages/HomePage.vue'
import ConnexionPage from '@/pages/ConnexionPage.vue'
import InscriptionPage from '@/pages/InscriptionPage.vue'
import MonComptePage from '@/pages/MonComptePage.vue'
import OrdresFabricationPage from '@/pages/OrdresFabricationPage.vue'
import OrdreFabricationPage from '@/pages/OrdreFabricationPage.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '',
      component: MainLayout,
      children: [
        // page d'accueil
        {
          path: '',
          name: 'accueil',
          meta: {
            requiresAuth: true,
            title: 'Accueil',
          },
          component: HomePage,
        },
        // connexion
        {
          path: 'connexion',
          name: 'connexion',
          meta: {
            requiresAuth: false,
            title: 'Connexion',
          },
          component: ConnexionPage,
        },
        // inscription
        {
          path: 'inscription',
          name: 'inscription',
          meta: {
            requiresAuth: false,
            title: 'Inscription',
            back: 'connexion',
          },
          component: InscriptionPage,
        },
        // mon compte
        {
          path: 'mon-compte',
          name: 'mon-compte',
          meta: {
            requiresAuth: true,
            title: 'Mon Compte',
          },
          component: MonComptePage,
        },
        // ordres de fabrication
        {
          path: 'ordres-fabrication',
          meta: {
            requiresAuth: true,
            title: 'Ordres de fabrication',
          },
          name: 'ordres-fabrication',
          component: OrdresFabricationPage,
        },
        {
          path: 'ordre-fabrication',
          meta: {
            requiresAuth: true,
            back: 'ordres-fabrication',
          },
          children: [
            {
              path: '',
              name: 'ordre-fabrication-creation',
              component: OrdreFabricationPage,
              meta: {
                title: "Création d'un OF",
              },
            },
            {
              path: ':id',
              name: 'ordre-fabrication-modification',
              component: OrdreFabricationPage,
              meta: {
                title: "Modification d'un OF",
              },
            },
          ],
        },
        // admin
        {
          path: 'admin',
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
          },
          children: [
            // gestion des utilisateurs
            {
              path: 'utilisateurs',
              meta: {
                title: 'Utilisateurs',
              },
              name: 'utilisateurs',
              component: UtilisateursPage,
            },
            {
              path: 'utilisateur',
              meta: {
                requiresAuth: true,
                requiresAdmin: true,
                back: 'utilisateurs',
              },
              children: [
                {
                  path: '',
                  name: 'utilisateur-creation',
                  component: UtilisateurPage,
                  meta: {
                    title: "Création d'un utilisateur",
                  },
                },
                {
                  path: ':id',
                  name: 'utilisateur-modification',
                  component: UtilisateurPage,
                  meta: {
                    title: "Modification d'un utilisateur",
                  },
                },
              ],
            },
            // équipements
            {
              path: 'equipements',
              meta: {
                title: 'Equipements',
              },
              name: 'equipements',
              component: EquipementsPage,
            },
            {
              path: 'equipement',
              meta: {
                requiresAuth: true,
                requiresAdmin: true,
                back: 'equipements',
              },
              children: [
                {
                  path: '',
                  name: 'equipement-creation',
                  component: EquipementPage,
                  meta: {
                    title: "Création d'un équipement",
                  },
                },
                {
                  path: ':id',
                  name: 'equipement-modification',
                  component: EquipementPage,
                  meta: {
                    title: "Modification d'un équipement",
                  },
                },
              ],
            },
            // produits de filtration
            {
              path: 'produits-filtration',
              meta: {
                title: 'Produits de filtration',
              },
              name: 'produits-filtration',
              component: ProduitsFiltrationPage,
            },
            {
              path: 'produit-filtration',
              meta: {
                requiresAuth: true,
                requiresAdmin: true,
                back: 'produits-filtration',
              },
              children: [
                {
                  path: '',
                  name: 'produit-filtration-creation',
                  component: ProduitFiltrationPage,
                  meta: {
                    title: "Création d'un produit de filtration",
                  },
                },
                {
                  path: ':id',
                  name: 'produit-filtration-modification',
                  component: ProduitFiltrationPage,
                  meta: {
                    title: "Modification d'un produit de filtration",
                  },
                },
              ],
            },
            // clients
            {
              path: 'clients',
              meta: {
                title: 'Clients',
              },
              name: 'clients',
              component: ClientsPage,
            },
            {
              path: 'client',
              meta: {
                requiresAuth: true,
                requiresAdmin: true,
                back: 'clients',
              },
              children: [
                {
                  path: '',
                  name: 'client-creation',
                  component: ClientPage,
                  meta: {
                    title: "Ajout d'un client",
                  },
                },
                {
                  path: ':id',
                  name: 'client-modification',
                  component: ClientPage,
                  meta: {
                    title: "Modification d'un client",
                  },
                },
              ],
            },
            // fabricants
            {
              path: 'fabricants',
              meta: {
                title: 'Fabricants',
              },
              name: 'fabricants',
              component: FabricantsPage,
            },
            {
              path: 'fabricant',
              meta: {
                requiresAuth: true,
                requiresAdmin: true,
                back: 'fabricants',
              },
              children: [
                {
                  path: '',
                  name: 'fabricant-creation',
                  component: FabricantPage,
                  meta: {
                    title: "Ajout d'un fabricant",
                  },
                },
                {
                  path: ':id',
                  name: 'fabricant-modification',
                  component: FabricantPage,
                  meta: {
                    title: "Modification d'un fabricant",
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  const userStore = useUserStore()
  // si l'utilisateur n'est pas encore récupéré, on le récupère avant de vérifier ses droits d'accès
  if (!userStore.isAuthenticated) await userStore.getUtilisateur()

  // titre de la page
  const title = import.meta.env.VITE_TITLE
  if (to.meta.title) document.title = `${title} - ${to.meta.title.toString()}`
  else document.title = title

  // if route require being authenticated, but user is not authenticated
  if (to.matched.some((record) => record.meta.requiresAuth) && !userStore.isAuthenticated) {
    // redirect to login page
    await router.push({ name: 'connexion' })

    // if route require being unauthenticated, but user is authenticated
  } else if (
    to.matched.some((record) => record.meta.requiresAuth === false) &&
    userStore.isAuthenticated
  ) {
    // redirect to user page
    await router.push({ name: 'accueil' })

    // if route require being admin, but user is not admin or not authenticated
  } else if (
    to.matched.some((record) => record.meta.requiresAdmin) &&
    (!userStore.isAuthenticated || !userStore.isAdmin)
  ) {
    // redirect to home page
    await router.push({ name: 'accueil' })
  }
  // continue to route
  next()
})

export default router
